import {
  ActiveDayIndicator,
  ActiveDayIndicatorsWrapper,
  ActiveDayTypography,
} from 'src/features/locations/calendarLocationPage/modules/ActiveDayIndicators/ActiveDayIndicators.styled';
import { IActiveDay } from 'src/interfaces';
import { lang } from 'src/utils';

export interface IActiveDayIndicators {
  activeDays?: IActiveDay[];
}

export const ActiveDayIndicators = ({ activeDays }: IActiveDayIndicators) => {
  return (
    <ActiveDayIndicatorsWrapper>
      <ActiveDayTypography variant="body2">
        {lang.activeDays}
      </ActiveDayTypography>
      {activeDays?.map(({ active, label }, index) => (
        <ActiveDayIndicator key={index} $disabled={!active}>
          {label}
        </ActiveDayIndicator>
      ))}
    </ActiveDayIndicatorsWrapper>
  );
};
